import * as general from '../libs/general';
import { resolveRecordCreatedMeta } from '../libs/recordCreatedMeta';
import '../css/RecordCreatedMeta.css';

/**
 * Dòng «Đã tạo lúc … bởi …» dùng chung cho modal chi tiết.
 * Đặt ngay trên `.modal-footer` (ngoài `.modal-body`).
 */
const RecordCreatedMeta = ({
  record,
  createdAt,
  createdByName,
  recordId,
  className = '',
}) => {
  const meta = createdAt
    ? {
        createdAt,
        creator: createdByName?.trim() || '—',
      }
    : resolveRecordCreatedMeta(record, { recordId });

  if (!meta?.createdAt) {
    return null;
  }

  const formattedAt = general.formatDateTime2(meta.createdAt);
  if (!formattedAt || formattedAt === 'N/A') {
    return null;
  }

  return (
    <div className={`record-created-meta ${className}`.trim()}>
      <span className="record-created-meta__inner">
        <span className="record-created-meta__label">Đã tạo lúc</span>
        <strong className="record-created-meta__value">{formattedAt}</strong>
        <span className="record-created-meta__label">bởi</span>
        <strong className="record-created-meta__value">{meta.creator}</strong>
      </span>
    </div>
  );
};

export default RecordCreatedMeta;
